import { TranslationOptions } from '@bcp-channels-sharedcomponents-reactjs/core/dist/types';
import { AppHelper } from '@helpers';
import { useTranslation } from '@hooks';
import { useSearchParamsStore } from '@store';

import { logos } from '../logos';

export const PRIMARY_DARK_COLOR_TOKEN = 'primary-dark';
export const DEFAULT_BANNER_BACKGROUND = 'linear-gradient(135deg, #D1005D -0.21%, #E3669E 99.79%)';

export interface BannerContent {
	text?: string;
	leftIcon?: string;
	link?: { text?: string; url?: string };
	icon?: string;
	margin?: string;
}

export const useBannerHelper = () => {
	const { t: tHook } = useTranslation();
	const clientId = useSearchParamsStore((store) => store.clientId);
	const state = useSearchParamsStore((store) => store.state);

	// custom t function to return empty string if no translation provided
	const t = (masterKey: string, values?: object, options?: TranslationOptions): string => {
		return tHook(masterKey, values, options, true);
	};

	const handleCloseClick = (url: string) => {
		AppHelper.exit(url, 'cancelled', state);
	};

	const background = {
		mobile: t('components.banner.background.mobile') || DEFAULT_BANNER_BACKGROUND,
		desktop: t('components.banner.background.desktop') || DEFAULT_BANNER_BACKGROUND,
	};

	const LogoIcon = getLogoIcon(t('configs.corporateClientsList'), clientId);

	// show Exit link (or CloseIcon on mobile) if Url value is configured
	const exitUrl = t('components.banner.exit.url');
	const exit = { visible: Boolean(exitUrl), url: exitUrl };

	const contents = getContents(t);

	// LoggerHelper.log('App', 'useBannerHelper > [render]:', {
	// 	contents,
	// });

	return { t, handleCloseClick, background, LogoIcon, exit, contents };
};

const getLogoIcon = (corporateClientsList?: string, clientId?: string) => {
	const isCorporateClient = AppHelper.isCorporateClient(corporateClientsList, clientId);
	return isCorporateClient ? logos.MbcpEmpresasWhiteLogo : logos.MbcpWhiteLogo;
};

const getContents = (t: (masterKey: string, values?: object, options?: TranslationOptions) => string) => {
	// core.t.options.returnObject not working as expected
	// accepts a max of 10 contents from Sharepoint
	const contents: BannerContent[] = [];
	for (let i = 1; i <= 10; i++) {
		const content: BannerContent = {
			text: t(`components.banner.contents.${i}.text`),
			leftIcon: t(`components.banner.contents.${i}.leftIcon`),
			link: {
				text: t(`components.banner.contents.${i}.link.text`),
				url: t(`components.banner.contents.${i}.link.url`),
			},
			icon: t(`components.banner.contents.${i}.icon`),
			margin: t(`components.banner.contents.${i}.margin`),
		};

		contents.push(content);
	}

	return contents;
};
